import { makeWebPageSchema } from './makeWebPageSchema';
export const stringifyWebpageSchema = ({ lang, name, description, url, }) => {
    const webpageSchema = makeWebPageSchema({
        lang: lang,
        name: name,
        description: description,
        url: url,
    });
    return JSON.stringify(webpageSchema, null, 2);
};
export default stringifyWebpageSchema;
